import { salesRoleChoices } from "./roles";
export type RoleProfile = {
  id: string;
  name: string;
  base: string;
  contacts: "none" | "read" | "edit" | "manage";
  companies: "none" | "read" | "edit" | "manage";
  calendar: boolean;
  projects: boolean;
  logs: string[];
  logScope?: "own" | "available";
};
export const logChoices = [
  { id: "created", name: "Создание" },
  { id: "updated", name: "Изменения" },
  { id: "status", name: "Статусы" },
  { id: "comments", name: "Комментарии" },
  { id: "deleted", name: "Удаление" },
  { id: "expenses", name: "Расходы" },
  { id: "other", name: "Прочее" },
];
const original = salesRoleChoices.map((x) => ({ ...x }));
export const defaultProfiles = (): RoleProfile[] =>
  original.map((r) => ({
    ...r,
    base: r.id,
    contacts: r.id === "junior_manager" ? "manage" : "none",
    companies: r.id === "junior_manager" ? "manage" : "none",
    calendar: true,
    projects: r.id === "manager",
    logs: logChoices.map((x) => x.id),
  }));
let profiles = defaultProfiles();
export const roleProfiles = () => profiles;
export const roleProfile = (id?: string) => profiles.find((p) => p.id === id);
export const baseRole = (id: string) => roleProfile(id)?.base ?? id;
export function installRoleProfiles(next: RoleProfile[]) {
  profiles = next;
  salesRoleChoices.splice(
    0,
    salesRoleChoices.length,
    ...next.map((p) => ({ id: p.id, name: p.name })),
  );
}
export function profilePermission(
  role: string,
  resource: string,
  action: string,
): boolean | undefined {
  const p = roleProfile(role);
  if (!p) return undefined;
  if (resource === "counterparties")
    return p.contacts !== "none" || p.companies !== "none";
  const read = ["list", "read", "show"].includes(action);
  const section = [
    "contacts",
    "contacts_summary",
    "contact_notes",
    "tags",
  ].includes(resource)
    ? "contacts"
    : ["companies", "companies_summary"].includes(resource)
      ? "companies"
      : null;
  if (resource === "tags") return read && p.contacts !== "none";
  if (action === "merge") return false;
  if (section)
    return (
      p[section] === "manage" ||
      (p[section] === "edit" && action !== "delete") ||
      (p[section] === "read" && read)
    );
  if (resource === "calendar" || resource === "tasks") return p.calendar;
  if (resource === "work_projects") return p.projects && read;
  if (resource === "activity_log") return p.logs.length > 0 && read;
  return undefined;
}
